import { render } from "./EmptyListMessage.vue?vue&type=template&id=4adff4a1"
import script from "./EmptyListMessage.vue?vue&type=script&lang=js"
export * from "./EmptyListMessage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__